import { Container, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Plus from 'mdi-material-ui/Plus'
import { useState } from 'react'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogFaq from '../../views/faq/DialogFaq'
import TableFaq from '../../views/faq/TableFaq'


const FaqList = () => {
    const [reload, setReload] = useState(0)
    const [show, setShow] = useState(false)

    return (
        <Page title="Faq">
            <Grid container spacing={6}>
            <PageHeader
                title={
                <Typography variant='h5' color='#666CFF'>
                    FAQ
                </Typography>
                }
                subtitle={
                <Typography variant='body2'>
                    FAQ 리스트를 보여줍니다.
                </Typography>
                }
            />
            <BoxWrapper>
                <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >등록</Button>
            </BoxWrapper>
            <DialogFaq show={show} setShow={setShow} setReload={setReload} />
            <Grid item xs={12}>        
                <TableFaq reload={reload} setReload={setReload} />
            </Grid>
            </Grid>
        </Page>
    )
}

export default FaqList